import React, { Component } from 'react';
import { Sale } from 'types/type';
import { AccessToken } from 'routes/login/redux/reducers';
import { RouteComponentProps } from 'react-router';
import { RootState } from 'store/configureStore';
import { login } from '../login/redux/actions';
import { connect } from 'react-redux';
import { Button, Form, Popover } from 'antd';
import { QrcodeOutlined } from '@ant-design/icons';
import Scanner from './Scanner';
import { ButtonShape, ButtonSize, ButtonType } from 'antd/lib/button';
import './style.css';

interface DispatchProps {
  login: (username: string, password: string) => void;
}
interface StateProps {
  accessToken: AccessToken;
  readonly isFetching: boolean;
  readonly scannedQR: string;
}

interface ButtonProps {
  onContinue: (sales: Sale[]) => void;
  type?: ButtonType;
  shape?: ButtonShape;
  size?: ButtonSize;
  children?: React.ReactNode;
}

interface ScannerButtonState {
  qrModalVisible: boolean;
}

type Props = DispatchProps & StateProps & RouteComponentProps & ButtonProps;

class ScannerButton extends Component<Props> {
  public state: ScannerButtonState = {
    qrModalVisible: false,
  };

  componentDidMount(): void {
    if (this.props.scannedQR !== '') {
      this.setState({ qrModalVisible: true });
    }
  }

  componentDidUpdate(
    prevProps: Record<string, unknown>,
    prevState: ScannerButtonState,
  ) {
    if (this.state.qrModalVisible !== prevState.qrModalVisible) {
      if (this.state.qrModalVisible) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  }

  public onContinueQrModal = (sales: Sale[]) => {
    this.props.onContinue(sales);
    this.setState({ qrModalVisible: false });
  };

  public render = (): JSX.Element => {
    const { type, shape, size } = this.props;
    return (
      <div>
        <Scanner
          visible={this.state.qrModalVisible}
          onContinue={this.onContinueQrModal}
        />
        <Popover content={'Añadir IUS'}>
          <Button
            type={type || 'ghost'}
            shape={shape}
            size={size || 'default'}
            onClick={() => this.setState({ qrModalVisible: true })}
          >
            <QrcodeOutlined />
            {this.props.children}
          </Button>
        </Popover>
      </div>
    );
  };
}

const mapStateToProps = (states: RootState): StateProps => {
  return {
    accessToken: states.loginState.accessToken,
    isFetching: states.invoiceState.isFetching,
    scannedQR: states.invoiceState.scannedQR,
  };
};

/**
 * Maps the possible actions that can be executed in this component.
 */
const mapDispatchToProps = {
  login,
};

export default connect<StateProps, DispatchProps, ButtonProps, RootState>(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(ScannerButton));
